import { configuredSupabaseUrl } from "@/integrations/supabase/client";

export function getSupabaseFunctionsBaseUrl(): string {
  return `${configuredSupabaseUrl}/functions/v1`;
}

export function getSupabaseFunctionUrl(functionName: string): string {
  const normalizedName = functionName.replace(/^\/+/, "");
  return `${getSupabaseFunctionsBaseUrl()}/${normalizedName}`;
}
